import { render, staticRenderFns } from "./SummaryCardBodyMapHands.vue?vue&type=template&id=12a044ce&"
import script from "./SummaryCardBodyMapHands.vue?vue&type=script&lang=js&"
export * from "./SummaryCardBodyMapHands.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/components/views/dashboard/members/id/partial/cards/das-card.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports